// @flow
import * as React from 'react';
import { datadogLogsHandler } from 'utils/datadog';
import { logError } from '../../utils/handleErrors';

type ErrorInfo = {
  componentStack: string,
};

type State = {| hasError: boolean |};

type Props = {|
  fallbackUI: React.Node,
  handleError?: (error: Error, errorInfo: ErrorInfo) => void,
  children: React.Node,
|};

class ErrorBoundary extends React.Component<Props, State> {
  state = { hasError: false };

  static defaultProps = { fallbackUI: <></> };

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    logError(error, info);
    if (this.props.handleError) {
      this.props.handleError(error, info);
      return;
    }
    datadogLogsHandler(error, info);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallbackUI;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
